export const ActionTypes = {
    GET_TENANT_BY_ID: "GET_TENANT_BY_ID",
    GET_TENANT_LIST:"GET_TENANT_LIST",
    GET_MASTER_SETTING_BY_ID: "GET_MASTER_SETTING_BY_ID",
    GET_MASTER_SETTING_LIST:"GET_MASTER_SETTING_LIST",
    RESET_STATE: 'RESET_STATE',
    GET_DEFAULT_TEMPLATE_LIST:"GET_DEFAULT_TEMPLATE_LISTS",
};
